import Api from 'src/controllers/api';
import Logger from 'src/utils/logger';

/**
 * Questa funzione fa partire il tracciamento
 * mandando il beat ogni 2 minuti.
 */
const init = (userId, endEvent) => {
  Logger('debug', 'Start analytics...');
  // Mando il beat ogni 2 minuti.
  return setInterval(
    () => Api.sendBeatToAnalytics(userId, endEvent),
    1000 * 60 * 2,
  );
};

const stopAnalytics = () => {
  clearInterval(window.analyticsJob);
};

export default { init, stopAnalytics };
